import ContentLoader from 'react-content-loader'

const ChartCardContentLoader = () => {
  return (
    <ContentLoader
      speed={0.75}
      width="100%"
      height={600}
      viewBox="0 0 800 400"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      style={{ width: '100%', height: 'auto' }}
    >
      <rect x="20" y="20" rx="4" ry="4" width="760" height="30" />
      <rect x="20" y="70" rx="4" ry="4" width="760" height="500" />
    </ContentLoader>
  )
}

export default ChartCardContentLoader
